import React from "react";
import { statusLabel, statusTone } from "../../utils/status";

export default function StatusPill({ order }) {
	return <span className={`status-pill ${statusTone(order?.bidRequestState)}`}>{statusLabel(order)}</span>;
}
